module.exports = __webpack_public_path__ + "img/about_logo_26.e1e9252f.png";